import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ChangeCompany } from 'src/app/core/actions/company.action';
import { SessionCompanies } from 'src/app/core/actions/session-companies.action';
import { CompanyPreview } from 'src/app/core/interfaces/company-preview.interface';
import { CompanyService } from 'src/app/core/services/company.service';
// import { ImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ImageCropperComponent } from '@ccab/components-lib';

@Component({
  selector: 'app-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.scss'],
  styles: [
    `
      :host {
        border-radius: 50%;
      }
    `
  ]
})
export class CompanyLogoComponent implements OnInit {
  @Input() edit: boolean = false;
  @Input() size: number = 50;
  @Input() companyId: number;
  @Input() url: string | SafeResourceUrl;
  @Input() saveEvent: Observable<boolean> = new Observable<any>();

  isDragOver: boolean = false;
  updating: boolean;
  destroy$ = new Subject();
  company$: Observable<CompanyPreview>;
  sessionCompanies$: Observable<CompanyPreview[]>;
  companies: CompanyPreview[];
  company: CompanyPreview;
  _event: any;
  _file: any;

  constructor(
    private readonly companyService: CompanyService,
    private readonly dialog: MatDialog,
    private readonly sanitizer: DomSanitizer,
    private readonly companyStore: Store<CompanyPreview>,
    private readonly sessionCompaniesStore: Store<CompanyPreview[]>,
    private readonly sessionCompaniesState: Store<{
      sessionCompanies: CompanyPreview[];
    }>,
    private readonly companyState: Store<{ company: CompanyPreview }>
  ) {
    this.sessionCompanies$ = this.sessionCompaniesState.pipe(select('sessionCompanies'));
    this.company$ = this.companyState.pipe(select('company'));
  }

  async ngOnInit() {
    if (!this.url) {
      this.url = '../../../../../assets/img/empty-company-logo.png';
    }

    this.sessionCompanies$.pipe(takeUntil(this.destroy$)).subscribe(async (companies) => {
      if (companies) {
        this.companies = [...companies];
      }
    });
    this.company$.pipe(takeUntil(this.destroy$)).subscribe((company) => {
      if (company) {
        this.company = { ...company };
      }
    });

    this.saveEvent.pipe(takeUntil(this.destroy$)).subscribe((save) => {
      if (save) {
        this.uploadImage();
      }
    });
  }

  onDragOverEvent(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();
    if (this.edit) {
      this.isDragOver = true;
    }
  }
  async onFileDrop(event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.edit && this.companyId > 0) {
      if (this.isValidFile(event.dataTransfer.files[0])) {
        this.openCropperDialog(event.dataTransfer.files[0]);
      }

      this.isDragOver = false;
    }
  }
  async imageAdd(event) {
    if (this.isValidFile(event[0]) && this.companyId > 0) {
      this.openCropperDialog(event.item(0));
    }
  }
  onDragLeave(event: DragEvent) {
    event.stopPropagation();
    event.preventDefault();
    if (this.edit) {
      this.isDragOver = false;
    }
  }

  changeImage() {
    var reader = new FileReader();
    reader.readAsDataURL(this._file);
    reader.onload = (event) => {
      this.url = this.sanitizer.bypassSecurityTrustUrl(event.target.result.toString());
    };
  }

  async uploadImage() {
    if (this._file) {
      try {
        this.updating = true;
        let response = await this.companyService.updateCompanyLogo(this._file, this.companyId);
        if (response.success) {
          this.setCompanyLogo(this.url);
        }
        this.updating = false;
      } catch (e) {
        this.updating = false;
      }
    }
  }
  setCompanyLogo(url) {
    this.url = url;
    let index = this.companies.findIndex((c) => c.id === this.companyId);
    if (index >= 0) {
      let compan = { ...this.companies[index] };
      compan.logo = url;
      this.companies[index] = compan;
      this.sessionCompaniesStore.dispatch(SessionCompanies(this.companies));
    }

    if (this.company?.id === this.companyId) {
      this.company.logo = undefined;
      this.companyStore.dispatch(ChangeCompany(this.company));
    }
  }
  openCropperDialog(file: File) {
    if (this.isValidFile(file)) {
      let dialogRef = this.dialog.open(ImageCropperComponent, {
        data: {
          file: file,
          aspectRatio: 1 / 1,
          roundCropper: true,
          resizeToWidth: 300,
          resizeToHeight: 300,
          cropperMinWidth: 200
        }
      });

      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((e) => {
          if (e) {
            this._file = new File([e], 'company_logo.jpg');
            this.changeImage();
          }
        });
    }
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  isValidFile(file) {
    return file.type.split('/')[0] === 'image';
  }
}
